/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a coding sequence above to translate it.`)
};

const es_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia codificante arriba para traducirla.`)
};

const de_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben eine Kodierungssequenz ein, um sie zu übersetzen.`)
};

const nl_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een coderende sequentie om deze te vertalen.`)
};

const fr_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence codante ci-dessus pour la traduire.`)
};

const it_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza codificante sopra per tradurla.`)
};

const pt_br2_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante acima para traduzi-la.`)
};

const pt_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência codificante acima para a traduzir.`)
};

const ja_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上にコード配列を貼り付けると翻訳されます。`)
};

const zh_translate_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴编码序列以进行翻译。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_hint_empty", locale)
	if (locale === "en") return en_translate_hint_empty(inputs)
	if (locale === "es") return es_translate_hint_empty(inputs)
	if (locale === "de") return de_translate_hint_empty(inputs)
	if (locale === "nl") return nl_translate_hint_empty(inputs)
	if (locale === "fr") return fr_translate_hint_empty(inputs)
	if (locale === "it") return it_translate_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_translate_hint_empty(inputs)
	if (locale === "pt") return pt_translate_hint_empty(inputs)
	if (locale === "ja") return ja_translate_hint_empty(inputs)
	return zh_translate_hint_empty(inputs)
};